import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tableList, fileDownload, getNoticeList, bpmnStuAndteachStastic } from "@/api/portrayal/policy";
import { getUser } from "@/api/management/user";
import { stuAndteachStastic } from "@/api/home/home";
import { getCardList } from "@/api/managementCenter/specialManage";
import { handleDownload } from "@/api/managementCenter/otherApi";
export default {
  name: "LINKMAGA",
  components: {},
  props: ["moduleData"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      rulesList: [],
      businessList: [],
      downloadList: []
    };
  },
  computed: {},
  created: function created() {
    this.getCardData("3");
    this.getCardData("4");
    this.getCardData("5");
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: (_methods = {
    getCardData: function getCardData(type) {
      var _this = this;

      var params = {
        type: type || ""
      };
      getCardList(params).then(function (res) {
        if (type == "3") {
          _this.rulesList = res.data.data.records;
        }

        if (type == "4") {
          _this.businessList = res.data.data.records;
        }

        if (type == "5") {
          _this.downloadList = res.data.data.records;
        }
      });
    },
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    clickServeItem: function clickServeItem(item) {
      var _this2 = this;

      switch (item.serveType) {
        case 0:
          this.$router.push({
            path: "/serveSearch/".concat(item.id, "/").concat(item.interfaceUrl)
          });
          break;

        case 1:
          this.$router.push({
            path: "/serveApproval/".concat(item.id)
          });
          break;

        case 2:
          this.$router.push({
            path: "/serveCustomized/".concat(item.id, "/").concat(item.interfaceUrl)
          });
          break;

        case 9:
          this.$http.post("/statistical/serverInsert", this.$qs.stringify({
            serviceId: item.id,
            appType: 9
          })).then(function () {}).catch(function () {});
          this.url = item.linkUrl;
          this.$nextTick(function () {
            _this2.$refs.url.click();
          });
          break;

        default:
          break;
      }
    },
    iconClick: function iconClick(val) {
      val == "TINFO_RULES" ? this.getCardData("3") : val == "TINFO_BUSINESS" ? this.getCardData("4") : this.getCardData("5");
    },
    goHref: function goHref(item, path) {
      var routeData = this.$router.resolve({
        name: path,
        query: {
          id: item.ntiId || item.id,
          fileId: item.fileId || "",
          type: item.ntiType || ""
        }
      });
      window.open(routeData.href);
    },
    goPagination: function goPagination(code) {
      var type = code === "TINFO_RULES" ? "3" : code === "TINFO_BUSINESS" ? "4" : "5";
      var routeData = this.$router.resolve({
        name: "/noticesAndFilesPagination",
        query: {
          type: type
        }
      });
      window.open(routeData.href);
    }
  }, _defineProperty(_methods, "goHref", function goHref(item, path) {
    var routeData = this.$router.resolve({
      name: path,
      query: {
        id: item.ntiId || item.id,
        fileId: item.fileId || "",
        type: item.ntiType || ""
      }
    });
    window.open(routeData.href);
  }), _defineProperty(_methods, "downLoadFile", function downLoadFile(item) {
    var _this3 = this;

    this.$DownLoad(handleDownload(item.id), null, function (res) {
      if (res.status == 200) {} else {
        _this3.$alert("下载出错,请稍后重试", "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      }
    }, function (error) {
      _this3.$alert(error, "提示", {
        confirmButtonText: "确定",
        type: "warning"
      });
    });
  }), _methods),
  watch: {},
  filters: {}
};